/*
	import { listRecurringEvents } from '@/services/CalendarEvent/CommunityCalendarRecurringEvent/List';

  const { list, successful, message } = await listRecurringEvents ({
    params: {
			hoaID
    }
  });
  if (!successful) {
    console.error (message);
    return;
  }
*/

import _get from 'lodash/get'
import kms from '@/services/kms'

export async function listRecurringEvents({ params }) {
  let message = 'The community calendar recurring events list could not be retrieved.'

  try {
    const result = await kms.get(`/CalendarEvent/CommunityCalendarRecurringEvent/List`, {
      params
    })

    let list = _get(result, 'results', [])
    if (!Array.isArray(list)) {
      list = []
    }

    return {
      successful: true,
      message,
      list
    }
  } catch (exception) {
    console.error(exception)
  }

  return {
    successful: false,
    message,
    list: []
  }
}
